import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';
import { Package, Search, ArrowRight, RefreshCcw, FileEdit } from 'lucide-react';

export function GRNStepSelectPO({ filteredPOs, loadingPOs, poSearchTerm, setPOSearchTerm, onSelectPO, onStartManual, onRefreshPOs }) {
  return (
    <div className="space-y-4">
      {/* Manual GRN Option */}
      <div 
        className="p-4 border-2 border-dashed border-orange-300 rounded-lg bg-orange-50 hover:border-orange-400 hover:bg-orange-100 cursor-pointer transition-colors"
        onClick={onStartManual}
        data-testid="manual-grn-btn"
      >
        <div className="flex items-center gap-4">
          <div className="p-3 bg-orange-200 rounded-full">
            <FileEdit className="w-6 h-6 text-orange-700" />
          </div>
          <div className="flex-1">
            <p className="font-semibold text-orange-800">Create Manual GRN</p>
            <p className="text-sm text-orange-600">Receive stock without a Purchase Order (direct purchase, returns, adjustments)</p>
          </div>
          <ArrowRight className="w-5 h-5 text-orange-500" />
        </div>
      </div>
      
      <div className="relative flex items-center py-2">
        <div className="flex-1 border-t border-gray-200"></div>
        <span className="px-4 text-sm text-gray-500 bg-white">OR select a Purchase Order</span>
        <div className="flex-1 border-t border-gray-200"></div>
      </div>
      
      <div className="flex items-center gap-3">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} />
          <Input
            placeholder="Search by PO number or supplier..."
            value={poSearchTerm}
            onChange={(e) => setPOSearchTerm(e.target.value)}
            className="pl-9"
            data-testid="po-search-input"
          />
        </div>
        <Button variant="outline" size="sm" onClick={onRefreshPOs} className="gap-1">
          <RefreshCcw className="w-4 h-4" />
          Refresh
        </Button>
      </div>
      
      {loadingPOs ? (
        <div className="text-center py-12 text-gray-500">
          <RefreshCcw className="w-8 h-8 animate-spin mx-auto mb-3 text-gray-400" />
          <p>Loading Purchase Orders...</p>
        </div>
      ) : filteredPOs.length === 0 ? (
        <div className="text-center py-12 text-gray-500">
          <Package className="w-12 h-12 mx-auto mb-3 text-gray-300" />
          <p className="font-medium">No Purchase Orders Available</p>
          <p className="text-sm mt-1">All POs have been fully received or no POs match your search</p>
        </div>
      ) : (
        <div className="space-y-3">
          {filteredPOs.map(po => (
            <div
              key={po.id}
              className="p-4 border rounded-lg hover:border-blue-300 hover:bg-blue-50 cursor-pointer transition-colors"
              onClick={() => onSelectPO(po)}
              data-testid={`select-po-${po.id}`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-blue-600">{po.po_number}</p>
                  <p className="text-sm text-gray-600">{po.supplier_name}</p>
                  {po.retailer_name && (
                    <p className="text-xs text-gray-500">For: {po.retailer_name}</p>
                  )}
                </div>
                <div className="text-right">
                  <Badge className={
                    po.status === 'partially_received' ? 'bg-yellow-100 text-yellow-800' :
                    'bg-blue-100 text-blue-800'
                  }>
                    {po.status?.toUpperCase().replace('_', ' ')}
                  </Badge>
                  <p className="text-xs text-gray-500 mt-1">
                    {po.items?.length || 0} items pending
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
